import { AnsweredQuestionCopy } from '@mindfulchefuk/components/FAQ/FAQ.types'

export const FAQGiftCardCopy: AnsweredQuestionCopy[] = [
  {
    question: 'Do gift cards have an expiry date?',
    answer:
      'The lucky recipient has 6 months to get cooking from the date this voucher is purchased.',
  },
  {
    question: 'Can I order a gift card for friends and family?',
    answer: `We have the ultimate gift cards to let friends or family discover our full healthy eating range - whether they want to do the cooking themselves with our award-winning recipe boxes, or let our chefs do it for them with our pre-prepared Mindful Meals!

      They can simply pop their unique voucher code into the voucher code box at the checkout.`,
  },
  {
    question: 'How do I redeem a gift card?',
    answer: `Simply enter your gift card code into the 'voucher code' box on the final page at the checkout. Once your voucher has been applied and payment details confirmed, just hit 'Place Order' to set up your account and get cooking! If you are an existing customer and wish to redeem a gift voucher, simply email us at hello@mindfulchef.com and we can sort this for you!`,
  },
  {
    question: 'What can gift cards be used for?',
    answer: `Any gift card you have on your Mindful Chef account will automatically apply to your next active order. If your gift card covers more than one order, it will continue to apply automatically to your subsequent orders until fully redeemed.`,
  },
  {
    question: 'When will the gift card arrive?',
    answer: `After your purchase, you will receive an email confirmation within an hour. This email will include step-by-step instructions on how to redeem the gift card.`,
  },
  {
    question: 'Can I purchase more than one gift card?',
    answer: `At this time, we do not offer the possibility to purchase multiple gift cards at once. We hope to be able to introduce this in the near future, so keep a lookout for future updates.`,
  },
]
